export default __webpack_public_path__ + "static/media/ann-tran-transformation.4d8f4d9f.jpeg";